import { render } from "./fleet-data.vue?vue&type=template&id=4ee10707"
import script from "./fleet-data.vue?vue&type=script&lang=js"
export * from "./fleet-data.vue?vue&type=script&lang=js"
script.render = render

export default script